<template>
  <div :class="formComputedClasses">
    <!-- Label -->
    <label :class="labelComputedClasses" :for="id">
      <span>{{ label }}</span>
      <ips-tooltip v-if="tooltip" :tooltip="tooltip">
        <template slot="tip">
          <ips-icon icon="ico-help"></ips-icon>
        </template>
      </ips-tooltip>
    </label>

    <div class="file-input">
      <input type="file" class="file" />
      <div class="custom-file-input input-group">
        <input
          :id="id"
          type="text"
          class="form-control"
          v-bind="selectedFileNames"
          :class="inputComputedClasses"
          :disabled="disabled"
          :multiple="multiple"
          :placeholder="placeholder"
          :required="required"
          :tabindex="tabindex"
          @change="handleFileChange"
        />
        <label class="input-group-text" :for="id">Browse</label>
      </div>
      <small v-if="error" class="ips-validation form-text text-danger">
        <ips-icon icon="ico-danger" size="sm"></ips-icon>
        <!-- @slot Use this slot to populate a validation/error message -->
        <slot name="errorText"></slot>
      </small>
    </div>
  </div>
</template>

<script>
import IpsIcon from '@ipscape/ips-icon';
import IpsTooltip from '@ipscape/ips-tooltip';
import { formFieldsMixin } from '../../../mixins/index.js';

export default {
  name: 'IpsFilePicker',
  components: { IpsIcon, IpsTooltip },
  mixins: [formFieldsMixin],
  props: {
    multiple: {
      name: 'multiple',
      description: 'If true multiple files can be selected',
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      files: null,
    };
  },
  computed: {
    selectedFileNames() {
      if (this.files === null) {
        return '';
      } else {
        if (this.files.length > 1) {
          return this.files.length + ' files';
        } else {
          return this.files[0] ? this.files[0].name : '';
        }
      }
    },
  },
  methods: {
    handleFileChange(event) {
      this.resetFiles();
      this.files = event.target.files;
      this.$emit('input', event.target.files);
    },
    resetFiles() {
      this.files = null;
      this.$emit('input', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'IpsFilePicker';
</style>
